/** 需方权限 */
export enum PurchaserPermission {
  /**  ================================ '对账管理 ================================ '*/
  /** 查看对账单 */
  StatementView = 'demander:reconciliation-management:view-reconciliation-statements',
  /** 新建对账单 */
  StatementNew = 'demander:reconciliation-management:create-reconciliation-statements',
  /** 编辑对账单 */
  StatementEdit = 'demander:reconciliation-management:edit-reconciliation-statements',
  /** 审核对账单 */
  StatementAudit = 'demander:reconciliation-management:audit-reconciliation-statements',
  /** 发布对账单 */
  StatementPublish = 'demander:reconciliation-management:publish-reconciliation-statements',
  /** 撤回对账单 */
  StatementCancelPublish = 'demander:reconciliation-management:recall-reconciliation-statements',
  /** 对账单付款 */
  StatementPay = 'demander:reconciliation-management:reconciliation-statement-payment',
  /** 批量付款 */
  StatementBatchPay = 'demander:reconciliation-management:batch-payment',
  /** 批量导出 */
  StatementBatchExport = 'demander:reconciliation-management:batch-export',
  /** 对账单查看回单记录 */
  ReconciliationReturnReceiptRecordView = 'demander:reconciliation-receipt:page',
  /**  ================================ 回单记录 ================================ */
  /** 回单记录列表 */
  ReturnReceiptRecordList = 'demander:receipt-record:list',
  /** 回单记录查看 */
  ReturnReceiptRecordView = 'demander:receipt-record:page',
  /**  ================================ 收支管理 ================================ '*/
  /** 查看收支记录 */
  IncomeExpenseRecordView = 'demand:revenue-record:detail',
  /** 新建收支记录 */
  IncomeExpenseRecordNew = 'demand:revenue-record:save',
  /** 编辑收支记录 */
  IncomeExpenseRecordEdit = 'demand:revenue-record:detail:update',
  /** 删除收支记录 */
  IncomeExpenseRecordDelete = 'demand:revenue-record:delete',
  /** 收支项目管理 */
  IncomeExpenseProjectManage = 'demand:revenue-record:manage:list',
  /** 批量删除收支记录 */
  IncomeExpenseRecordBatchDelete = 'demand:revenue-record:batchDelete',
  /** 批量导出 */
  IncomeExpenseRecordBatchExport = 'demand:revenue-record:exportExcel:record',
  /**  ================================ '应付汇总 ================================ '*/
  /** 批量导出 */
  PayAbleReportBatchExport = 'demander:payment-summary:view-summary-list',

  /**  ================================ '支付流水 ================================ '*/
  /** 查看付款单 */
  PaymentView = 'demander:payment-flow:view-payment-orders',
  /** 编辑付款单 */
  PaymentEdit = 'demander:payment-flow:edit-payment-orders',
  /** 提交付款单 */
  PaymentSubmit = 'demander:payment-flow:submit-payment-orders',
  /** 作废付款单 */
  PaymentAbort = 'demander:payment-flow:void-payment-orders',
  /** 删除付款单 */
  PaymentDelete = 'demander:payment-flow:delete-payment-orders',
  /** 批量提交 */
  PaymentBatchSubmit = 'demander:payment-flow:batch-submit',
  /** 批量作废 */
  PaymentBatchAbort = 'demander:payment-flow:batch-void',
  /** 批量删除 */
  PaymentBatchDelete = 'demander:payment-flow:batch-delete',
  /** 批量导出 */
  PaymentBatchExport = 'demander:payment-flow:batch-export',
  /**  ================================ 开票记录 ================================ */
  /** 查看开票记录 */
  BillRecordView = 'demand:invoice-record:get-info',
  /** 批量导出 */
  BillRecordBatchExport = 'demand:invoice-record:excel',
  /**  ================================ '采购单管理 ================================ '*/
  /** 审核采购单 */
  PurchaseAudit = 'demander:purchase-order-management:audit-purchase-orders',
  /** 查看采购单 */
  PurchaseView = 'demander:purchase-order-management:view-purchase-orders',
  /** 新建采购单 */
  PurchaseNew = 'demander:purchase-order-management:create-purchase-orders',
  /** 编辑采购单 */
  PurchaseEdit = 'demander:purchase-order-management:edit-purchase-orders',
  /** 采购单收货 */
  PurchaseReceive = 'demander:purchase-order-management:receive-purchase-orders',
  /** 采购单对账 */
  PurchaseCheck = 'demander:purchase-order-management:reconcile-purchase-orders',
  /** 采购单评价 */
  PurchaseEvaluate = 'demander:purchase-order-management:evaluate-purchase-orders',
  /** 采购单复制 */
  PurchaseCopy = 'demander:purchase-order-management:copy-purchase-orders',
  /** 采购单修改备注 */
  PurchaseUpdateRemark = 'demander:purchase-order-management:update-purchaseRemark',
  /** 查看质检报告 */
  PurchaseCheckReport = 'demander:purchase-order-management:view-quality-inspection-reports',
  /** 维护收获记录 */
  PurchaseReceipt = 'demander:purchase-order-management:maintain-receipt-records',
  /** 关闭采购单 */
  PurchaseClose = 'demander:purchase-order-management:close-purchase-orders',
  /** 删除采购单 */
  PurchaseDelete = 'demander:purchase-order-management:delete-purchase-orders',
  /** 批量采购 */
  PurchaseBatchPurchase = 'demander:purchase-order-management:batch-purchase',
  /** 批量导出 */
  PurchaseBatchExport = 'demander:purchase-order-management:batch-export',
  /** 批量收货 */
  PurchaseBatchReceive = 'demander:purchase-order-management:batch-receive',
  /** 补录采购单 */
  PurchaseRepair = 'demander:purchase-order-management:supplement-purchase',
  /** 批量对账 */
  PurchaseBatchCheck = 'demander:purchase-order-management:batch-reconcile',
  /** 批量关闭 */
  PurchaseBatchClose = 'demander:purchase-order-management:batch-close',
  /** 批量删除 */
  PurchaseBatchDelete = 'demander:purchase-order-management:batch-delete',
  /** 查看分拣记录 */
  PurchaseSortingRecordView = 'demander:purchase-order-management:view-sorting-record',
  /** 批量打标 */
  PurchaseBatchTag = 'demander:purchase-order-label:batch-add',
  /** 打印 */
  PurchasePrint = 'demander:purchase-order-management:print',
  /** 批量打印 */
  PurchaseBatchPrint = 'demander:purchase-order-management:batch-print',
  /** 批量改价 */
  PurchaseBatchEditPrice = 'demand:purchase-order-management:bulk-repricing',
  /** ================================ 预警管理-质检报告缺失 ================================ */
  WarningQualityReportMissingList = 'demander:quality-report-missing:view-purchase-order-list',
  WarningQualityReportMissingView = 'demander:quality-report-missing:view-purchase-orders',
  WarningQualityReportMissingAudit = 'demander:quality-report-missing:audit-purchase-orders',
  WarningQualityReportMissingCopy = 'demander:quality-report-missing:copy-purchase-orders',
  WarningQualityReportMissingEvaluate = 'demander:quality-report-missing:evaluate-purchase-orders',
  WarningQualityReportMissingCheck = 'demander:quality-report-missing:reconcile-purchase-orders',
  WarningQualityReportMissingReceive = 'demander:quality-report-missing:receive-purchase-orders',
  WarningQualityReportMissingSortingRecordView = 'demander:quality-report-missing:view-sorting-record',
  WarningQualityReportMissingClose = 'demander:quality-report-missing:close-purchase-orders',
  WarningQualityReportMissingDelete = 'demander:quality-report-missing:delete-purchase-orders',
  WarningQualityReportMissingUpdateRemark = 'demander:quality-report-missing:update-purchaseRemark',
  WarningQualityReportMissingEdit = 'demander:quality-report-missing:edit-purchase-orders',
  WarningQualityReportMissingPrint = 'demander:quality-report-missing:print',
  WarningQualityReportMissingBatchPrint = 'demander:quality-report-missing:batch-print',
  WarningQualityReportMissingBatchReceive = 'demander:quality-report-missing:batch-receive',
  WarningQualityReportMissingBatchCheck = 'demander:quality-report-missing:batch-reconcile',
  WarningQualityReportMissingBatchTag = 'demander:quality-report-missing:batch-add-label',
  WarningQualityReportMissingBatchDelete = 'demander:quality-report-missing:batch-delete',
  WarningQualityReportMissingBatchClose = 'demander:quality-report-missing:batch-close',
  WarningQualityReportMissingBatchEditPrice = 'demander:quality-report-missing:bulk-repricing',
  WarningQualityReportMissingBatchExport = 'demander:quality-report-missing:batch-export',
  /** 收货记录 */
  WarningQualityReportMissingReceiptRecordView = 'demander:quality-report-missing:maintain-receipt-records',
  /** 查看质检报告 */
  WarningQualityReportMissingInspectionReportView = 'demander:quality-report-missing:view-quality-inspection-reports',

  /** ================================ 预警管理-采购单差评 ================================ */
  WarningBadReviewsPurchaseList = 'demander:bad-reviews-purchase:view-purchase-order-list',
  WarningBadReviewsPurchaseView = 'demander:bad-reviews-purchase:view-purchase-orders',
  WarningBadReviewsPurchaseAudit = 'demander:bad-reviews-purchase:audit-purchase-orders',
  WarningBadReviewsPurchaseCopy = 'demander:bad-reviews-purchase:copy-purchase-orders',
  WarningBadReviewsPurchaseEvaluate = 'demander:bad-reviews-purchase:evaluate-purchase-orders',
  WarningBadReviewsPurchaseCheck = 'demander:bad-reviews-purchase:reconcile-purchase-orders',
  WarningBadReviewsPurchaseReceive = 'demander:bad-reviews-purchase:receive-purchase-orders',
  WarningBadReviewsPurchaseSortingRecordView = 'demander:bad-reviews-purchase:view-sorting-record',
  WarningBadReviewsPurchaseClose = 'demander:bad-reviews-purchase:close-purchase-orders',
  WarningBadReviewsPurchaseDelete = 'demander:bad-reviews-purchase:delete-purchase-orders',
  WarningBadReviewsPurchaseUpdateRemark = 'demander:bad-reviews-purchase:update-purchaseRemark',
  WarningBadReviewsPurchaseEdit = 'demander:bad-reviews-purchase:edit-purchase-orders',
  WarningBadReviewsPurchasePrint = 'demander:bad-reviews-purchase:print',
  WarningBadReviewsPurchaseBatchPrint = 'demander:bad-reviews-purchase:batch-print',
  WarningBadReviewsPurchaseBatchReceive = 'demander:bad-reviews-purchase:batch-receive',
  WarningBadReviewsPurchaseBatchCheck = 'demander:bad-reviews-purchase:batch-reconcile',
  WarningBadReviewsPurchaseBatchTag = 'demander:bad-reviews-purchase:batch-add-label',
  WarningBadReviewsPurchaseBatchDelete = 'demander:bad-reviews-purchase:batch-delete',
  WarningBadReviewsPurchaseBatchClose = 'demander:bad-reviews-purchase:batch-close',
  WarningBadReviewsPurchaseBatchEditPrice = 'demander:bad-reviews-purchase:bulk-repricing',
  WarningBadReviewsPurchaseBatchExport = 'demander:bad-reviews-purchase:batch-export',
  /** 收货记录 */
  WarningBadReviewsPurchaseReceiptRecordView = 'demander:bad-reviews-purchase:maintain-receipt-records',
  /** 查看质检报告 */
  WarningBadReviewsPurchaseInspectionReportView = 'demander:bad-reviews-purchase:view-quality-inspection-reports',
  /** ================================ 预警管理-采购单逾期送货 ================================ */
  WarningOverdueDeliveryPurchaseList = 'demander:overdue-delivery-purchase:view-purchase-order-list',
  WarningOverdueDeliveryPurchaseView = 'demander:overdue-delivery-purchase:view-purchase-orders',
  WarningOverdueDeliveryPurchaseAudit = 'demander:overdue-delivery-purchase:audit-purchase-orders',
  WarningOverdueDeliveryPurchaseCopy = 'demander:overdue-delivery-purchase:copy-purchase-orders',
  WarningOverdueDeliveryPurchaseEvaluate = 'demander:overdue-delivery-purchase:evaluate-purchase-orders',
  WarningOverdueDeliveryPurchaseCheck = 'demander:overdue-delivery-purchase:reconcile-purchase-orders',
  WarningOverdueDeliveryPurchaseReceive = 'demander:overdue-delivery-purchase:receive-purchase-orders',
  WarningOverdueDeliveryPurchaseSortingRecordView = 'demander:overdue-delivery-purchase:view-sorting-record',
  WarningOverdueDeliveryPurchaseClose = 'demander:overdue-delivery-purchase:close-purchase-orders',
  WarningOverdueDeliveryPurchaseDelete = 'demander:overdue-delivery-purchase:delete-purchase-orders',
  WarningOverdueDeliveryPurchaseUpdateRemark = 'demander:overdue-delivery-purchase:update-purchaseRemark',
  WarningOverdueDeliveryPurchaseEdit = 'demander:overdue-delivery-purchase:edit-purchase-orders',
  WarningOverdueDeliveryPurchasePrint = 'demander:overdue-delivery-purchase:print',
  WarningOverdueDeliveryPurchaseBatchPrint = 'demander:overdue-delivery-purchase:batch-print',
  WarningOverdueDeliveryPurchaseBatchReceive = 'demander:overdue-delivery-purchase:batch-receive',
  WarningOverdueDeliveryPurchaseBatchCheck = 'demander:overdue-delivery-purchase:batch-reconcile',
  WarningOverdueDeliveryPurchaseBatchTag = 'demander:overdue-delivery-purchase:batch-add-label',
  WarningOverdueDeliveryPurchaseBatchDelete = 'demander:overdue-delivery-purchase:batch-delete',
  WarningOverdueDeliveryPurchaseBatchClose = 'demander:overdue-delivery-purchase:batch-close',
  WarningOverdueDeliveryPurchaseBatchEditPrice = 'demander:overdue-delivery-purchase:bulk-repricing',
  WarningOverdueDeliveryPurchaseBatchExport = 'demander:overdue-delivery-purchase:batch-export',
  /** 收货记录 */
  WarningOverdueDeliveryPurchaseReceiptRecordView = 'demander:overdue-delivery-purchase:maintain-receipt-records',
  /** 查看质检报告 */
  WarningOverdueDeliveryPurchaseInspectionReportView = 'demander:overdue-delivery-purchase:view-quality-inspection-reports',
  /** ================================ 预警管理-采购单少送错送 ================================ */
  WarningLessDeliveryPurchaseList = 'demander:less-delivery-purchase:view-purchase-order-list',
  WarningLessDeliveryPurchaseView = 'demander:less-delivery-purchase:view-purchase-orders',
  WarningLessDeliveryPurchaseAudit = 'demander:less-delivery-purchase:audit-purchase-orders',
  WarningLessDeliveryPurchaseCopy = 'demander:less-delivery-purchase:copy-purchase-orders',
  WarningLessDeliveryPurchaseEvaluate = 'demander:less-delivery-purchase:evaluate-purchase-orders',
  WarningLessDeliveryPurchaseCheck = 'demander:less-delivery-purchase:reconcile-purchase-orders',
  WarningLessDeliveryPurchaseReceive = 'demander:less-delivery-purchase:receive-purchase-orders',
  WarningLessDeliveryPurchaseSortingRecordView = 'demander:less-delivery-purchase:view-sorting-record',
  WarningLessDeliveryPurchaseClose = 'demander:less-delivery-purchase:close-purchase-orders',
  WarningLessDeliveryPurchaseDelete = 'demander:less-delivery-purchase:delete-purchase-orders',
  WarningLessDeliveryPurchaseUpdateRemark = 'demander:less-delivery-purchase:update-purchaseRemark',
  WarningLessDeliveryPurchaseEdit = 'demander:less-delivery-purchase:edit-purchase-orders',
  WarningLessDeliveryPurchasePrint = 'demander:less-delivery-purchase:print',
  WarningLessDeliveryPurchaseBatchPrint = 'demander:less-delivery-purchase:batch-print',
  WarningLessDeliveryPurchaseBatchReceive = 'demander:less-delivery-purchase:batch-receive',
  WarningLessDeliveryPurchaseBatchCheck = 'demander:less-delivery-purchase:batch-reconcile',
  WarningLessDeliveryPurchaseBatchTag = 'demander:less-delivery-purchase:batch-add-label',
  WarningLessDeliveryPurchaseBatchDelete = 'demander:less-delivery-purchase:batch-delete',
  WarningLessDeliveryPurchaseBatchClose = 'demander:less-delivery-purchase:batch-close',
  WarningLessDeliveryPurchaseBatchEditPrice = 'demander:less-delivery-purchase:bulk-repricing',
  WarningLessDeliveryPurchaseBatchExport = 'demander:less-delivery-purchase:batch-export',
  /** 收货记录 */
  WarningLessDeliveryPurchaseReceiptRecordView = 'demander:less-delivery-purchase:maintain-receipt-records',
  /** 查看质检报告 */
  WarningLessDeliveryPurchaseInspectionReportView = 'demander:less-delivery-purchase:view-quality-inspection-reports',
  /** ================================ 预警管理-采购单破损包装 ================================ */
  WarningDamagedPackagePurchaseList = 'demander:damaged-package-purchase:view-purchase-order-list',
  WarningDamagedPackagePurchaseView = 'demander:damaged-package-purchase:view-purchase-orders',
  WarningDamagedPackagePurchaseAudit = 'demander:damaged-package-purchase:audit-purchase-orders',
  WarningDamagedPackagePurchaseCopy = 'demander:damaged-package-purchase:copy-purchase-orders',
  WarningDamagedPackagePurchaseEvaluate = 'demander:damaged-package-purchase:evaluate-purchase-orders',
  WarningDamagedPackagePurchaseCheck = 'demander:damaged-package-purchase:reconcile-purchase-orders',
  WarningDamagedPackagePurchaseReceive = 'demander:damaged-package-purchase:receive-purchase-orders',
  WarningDamagedPackagePurchaseSortingRecordView = 'demander:damaged-package-purchase:view-sorting-record',
  WarningDamagedPackagePurchaseClose = 'demander:damaged-package-purchase:close-purchase-orders',
  WarningDamagedPackagePurchaseDelete = 'demander:damaged-package-purchase:delete-purchase-orders',
  WarningDamagedPackagePurchaseUpdateRemark = 'demander:damaged-package-purchase:update-purchaseRemark',
  WarningDamagedPackagePurchaseEdit = 'demander:damaged-package-purchase:edit-purchase-orders',
  WarningDamagedPackagePurchasePrint = 'demander:damaged-package-purchase:print',
  WarningDamagedPackagePurchaseBatchPrint = 'demander:damaged-package-purchase:batch-print',
  WarningDamagedPackagePurchaseBatchReceive = 'demander:damaged-package-purchase:batch-receive',
  WarningDamagedPackagePurchaseBatchCheck = 'demander:damaged-package-purchase:batch-reconcile',
  WarningDamagedPackagePurchaseBatchTag = 'demander:damaged-package-purchase:batch-add-label',
  WarningDamagedPackagePurchaseBatchDelete = 'demander:damaged-package-purchase:batch-delete',
  WarningDamagedPackagePurchaseBatchClose = 'demander:damaged-package-purchase:batch-close',
  WarningDamagedPackagePurchaseBatchEditPrice = 'demander:damaged-package-purchase:bulk-repricing',
  WarningDamagedPackagePurchaseBatchExport = 'demander:damaged-package-purchase:batch-export',
  /** 收货记录 */
  WarningDamagedPackagePurchaseReceiptRecordView = 'demander:damaged-package-purchase:maintain-receipt-records',
  /** 查看质检报告 */
  WarningDamagedPackagePurchaseInspectionReportView = 'demander:damaged-package-purchase:view-quality-inspection-reports',
  /** ================================ 预警管理-采购单温湿异常 ================================ */
  WarningTemperatureHumidityPurchaseList = 'demander:temperature-humidity-purchase:view-purchase-order-list',
  WarningTemperatureHumidityPurchaseView = 'demander:temperature-humidity-purchase:view-purchase-orders',
  WarningTemperatureHumidityPurchaseAudit = 'demander:temperature-humidity-purchase:audit-purchase-orders',
  WarningTemperatureHumidityPurchaseCopy = 'demander:temperature-humidity-purchase:copy-purchase-orders',
  WarningTemperatureHumidityPurchaseEvaluate = 'demander:temperature-humidity-purchase:evaluate-purchase-orders',
  WarningTemperatureHumidityPurchaseCheck = 'demander:temperature-humidity-purchase:reconcile-purchase-orders',
  WarningTemperatureHumidityPurchaseReceive = 'demander:temperature-humidity-purchase:receive-purchase-orders',
  WarningTemperatureHumidityPurchaseSortingRecordView = 'demander:temperature-humidity-purchase:view-sorting-record',
  WarningTemperatureHumidityPurchaseClose = 'demander:temperature-humidity-purchase:close-purchase-orders',
  WarningTemperatureHumidityPurchaseDelete = 'demander:temperature-humidity-purchase:delete-purchase-orders',
  WarningTemperatureHumidityPurchaseUpdateRemark = 'demander:temperature-humidity-purchase:update-purchaseRemark',
  WarningTemperatureHumidityPurchaseEdit = 'demander:temperature-humidity-purchase:edit-purchase-orders',
  WarningTemperatureHumidityPurchasePrint = 'demander:temperature-humidity-purchase:print',
  WarningTemperatureHumidityPurchaseBatchPrint = 'demander:temperature-humidity-purchase:batch-print',
  WarningTemperatureHumidityPurchaseBatchReceive = 'demander:temperature-humidity-purchase:batch-receive',
  WarningTemperatureHumidityPurchaseBatchCheck = 'demander:temperature-humidity-purchase:batch-reconcile',
  WarningTemperatureHumidityPurchaseBatchTag = 'demander:temperature-humidity-purchase:batch-add-label',
  WarningTemperatureHumidityPurchaseBatchDelete = 'demander:temperature-humidity-purchase:batch-delete',
  WarningTemperatureHumidityPurchaseBatchClose = 'demander:temperature-humidity-purchase:batch-close',
  WarningTemperatureHumidityPurchaseBatchEditPrice = 'demander:temperature-humidity-purchase:bulk-repricing',
  WarningTemperatureHumidityPurchaseBatchExport = 'demander:temperature-humidity-purchase:batch-export',
  /** 收货记录 */
  WarningTemperatureHumidityPurchaseReceiptRecordView = 'demander:temperature-humidity-purchase:maintain-receipt-records',
  /** 查看质检报告 */
  WarningTemperatureHumidityPurchaseInspectionReportView = 'demander:temperature-humidity-purchase:view-quality-inspection-reports',
  /** ================================ 预警管理-健康证过期员工 ================================ */
  WarningHealthCertExpiredList = 'demander:employee-health-cert-expired:view-employee-list',
  WarningHealthCertExpiredView = 'demander:employee-health-cert-expired:view-employees',
  WarningHealthCertExpiredEdit = 'demander:employee-health-cert-expired:edit-employees',
  WarningHealthCertExpiredEnable = 'demander:employee-health-cert-expired:enable-employees',
  WarningHealthCertExpiredDisable = 'demander:employee-health-cert-expired:disable-employees',
  WarningHealthCertExpiredDelete = 'demander:employee-health-cert-expired:delete-employees',
  WarningHealthCertExpiredBatchEnable = 'demander:employee-health-cert-expired:batch-enable',
  WarningHealthCertExpiredBatchDisable = 'demander:employee-health-cert-expired:batch-disable',
  WarningHealthCertExpiredBatchDelete = 'demander:employee-health-cert-expired:batch-delete',
  WarningHealthCertExpiredBatchExport = 'demander:employee-health-cert-expired:export',
  /**  ================================ '价格监控 ================================ '*/
  /** 批量导出 */
  MonitorBatchExport = 'demander:price-monitoring:batch-export',

  /**  ================================ '计划到货明细 ================================ '*/
  /** 批量导出 */
  PlannedArrivalBatchExport = 'demander:planned-arrival-details:batch-export',

  /**  ================================ '采购汇总表 ================================ '*/
  /** 批量导出 */
  PurchaseReportBatchExport = 'demander:purchase-summary-table:batch-export',

  /**  ================================ '申购单管理 ================================ '*/
  /** 查看申购单 */
  PurchaseApplyView = 'demander:purchase-request-management:view-purchase-requests',
  /** 新建申购单 */
  PurchaseApplyNew = 'demander:purchase-request-management:create-purchase-requests',
  /** 编辑申购单 */
  PurchaseApplyEdit = 'demander:purchase-request-management:edit-purchase-requests',
  /** 发布申购单 */
  PurchaseApplyPublish = 'demander:purchase-request-management:publish-purchase-requests',
  /** 复制申购单 */
  PurchaseApplyCopy = 'demander:purchase-request-management:copy-purchase-requests',
  /** 关闭申购单 */
  PurchaseApplyClose = 'demander:purchase-request-management:close-purchase-requests',
  /** 删除申购单 */
  PurchaseApplyDelete = 'demander:purchase-request-management:delete-purchase-requests',
  /** 批量导出 */
  PurchaseApplyBatchExport = 'demander:purchase-request-management:batch-export',
  /** 批量关闭 */
  PurchaseApplyBatchClose = 'demander:purchase-request-management:batch-close',
  /** 批量删除 */
  PurchaseApplyBatchDelete = 'demander:purchase-request-management:batch-delete',
  /** 下达采购 */
  PurchaseSendApply = 'demander:purchase-request-management:add-purchase',
  /** 批量打标 */
  PurchaseApplyBatchTag = 'demander:purchase-request-labels:batch-add',
  /**  ================================ '申购单商品明细 ================================ '*/
  /** 申购商品明细列表 */
  PurchaseApplyGoodsDetailList = 'demander:purchase-request-commodity-details:view-details-list',
  /** 导出申购单商品明细 */
  PurchaseApplyDetailExport = 'demander:purchase-request-commodity-details:export-details',
  /** 查看申购商品明细 */
  PurchaseApplyGoodsDetailView = 'demander:purchase-request-commodity-details:view-details',
  /** 打印申购商品明细 */
  PurchaseApplyGoodsDetailPrint = 'demander:purchase-request-commodity-details:view-details-print',
  /** 批量打印申购商品明细 */
  PurchaseApplyGoodsDetailBatchPrint = 'demander:purchase-request-commodity-details:view-details-batch-print',
  /**  ================================ '用户管理 ================================ '*/
  /** 新建用户 */
  UserManageNew = 'demander:user-management:create-users',
  /** 编辑用户 */
  UserManageEdit = 'demander:user-management:edit-users',
  /** 修改密码 */
  UserManageEditPassword = 'demander:user-management:change-passwords',
  /** 启用用户 */
  UserManageEnable = 'demander:user-management:enable-users',
  /** 禁用用户 */
  UserManageDisable = 'demander:user-management:disable-users',
  /** 删除用户 */
  UserManageDelete = 'demander:user-management:delete-users',
  /** 批量启用 */
  UserManageBatchEnable = 'demander:user-management:batch-enable',
  /** 批量禁用 */
  UserManageBatchDisable = 'demander:user-management:batch-disable',
  /** 批量删除 */
  UserManageBatchDelete = 'demander:user-management:batch-delete',
  /** 数据权限 */
  DataPermission = 'demander:user-management:date-perimission',

  /**  ================================ '角色管理 ================================ '*/
  /** 新建角色 */
  RoleNew = 'demander:role-management:create-roles',
  /** 编辑角色 */
  RoleEdit = 'demander:role-management:edit-roles',
  /** 删除角色 */
  RoleDelete = 'demander:role-management:delete-roles',

  /**  ================================ '员工管理 ================================ '*/
  /** 查看员工 */
  EmployeeView = 'demander:employee-management:view-employees',
  /** 新建员工 */
  EmployeeNew = 'demander:employee-management:create-employees',
  /** 编辑员工 */
  EmployeeEdit = 'demander:employee-management:edit-employees',
  /** 启用员工 */
  EmployeeEnable = 'demander:employee-management:enable-employees',
  /** 禁用员工 */
  EmployeeDisable = 'demander:employee-management:disable-employees',
  /** 删除员工 */
  EmployeeDelete = 'demander:employee-management:delete-employees',
  /** 批量启用 */
  EmployeeBatchEnable = 'demander:employee-management:batch-enable',
  /** 批量禁用 */
  EmployeeBatchDisable = 'demander:employee-management:batch-disable',
  /** 批量删除 */
  EmployeeBatchDelete = 'demander:employee-management:batch-delete',
  /** 批量导入 */
  EmployeeBatchImport = 'demander:employee-management:import',
  /** 批量导出 */
  EmployeeBatchExport = 'demander:employee-management:export',
  /**  ================================ '菜谱汇总 ================================ '*/
  /** 菜谱汇总导出 */
  CookbookSummaryExport = 'demander:recipe-summary:export-purchase-summary',

  /**  ================================ '菜谱管理 ================================ '*/
  /** 查看菜谱 */
  CookbookView = 'demander:recipe-management:view-recipes',
  /** 新建自用菜谱 */
  CookbookNew = 'demander:recipe-management:create-self-use-recipes',
  /** 编辑自用菜谱 */
  CookbookEdit = 'demander:recipe-management:edit-self-use-recipes',
  /** 发布自用菜谱 */
  CookbookPublish = 'demander:recipe-management:publish-self-use-recipes',
  /** 复制自用菜谱 */
  CookbookCopy = 'demander:recipe-management:copy-self-use-recipes',
  /** 删除自用菜谱 */
  CookbookDelete = 'demander:recipe-management:delete-self-use-recipes',
  /** 关闭自用菜谱 */
  CookbookClose = 'demander:recipe-management:close-self-use-recipes',
  /** 批量删除 */
  CookbookBatchDelete = 'demander:recipe-management:batch-delete',
  /** 批量关闭 */
  CookbookBatchClose = 'demander:recipe-management:batch-close',
  /** 批量导出 */
  CookbookBatchExport = 'demander:recipe-management:batch-export',
  /** 下达申购 */
  CookbookIssueApply = 'demander:recipe-management:place-purchase-requests',
  /** 下达采购 */
  CookbookIssuePurchase = 'demander:recipe-management:place-purchases',

  /** 菜谱公示 */
  CookbookPub = 'demander:recipe-management:update-publish',
  /** 取消菜谱公示 */
  CookbookCancelPub = 'demander:recipe-management:cancel-update-publish',
  /** 批量菜谱公示 */
  CookbookBatchPub = 'demander:recipe-management:batch-update-publish',
  /** 批量取消公示 */
  CookbookBatchCancelPub = 'demander:recipe-management:batch-cancel-update-publish',

  /**  ================================ '账户流水 ================================ '*/
  /** 账户流水导出 */
  DemandAccountRecordsExport = 'demander:account-transaction:batch-export',

  /**  ================================ '入库单管理 ================================ '*/
  /** 查看入库单 */
  InboundView = 'demander:warehouse-inward-order-management:view-inward-orders',
  /** 编辑入库单 */
  InboundEdit = 'demander:warehouse-inward-order-management:edit-inward-orders',
  /** 提交入库单 */
  InboundSubmit = 'demander:warehouse-inward-order-management:submit-inward-orders',
  /** 关闭入库单 */
  InboundClose = 'demander:warehouse-inward-order-management:close-inward-orders',
  /** 删除入库单 */
  InboundDelete = 'demander:warehouse-inward-order-management:delete-inward-orders',
  /** 批量导出 */
  InboundExport = 'demander:warehouse-inward-order-management:batch-export',
  /** 批量提交 */
  InboundBatchSubmit = 'demander:warehouse-inward-order-management:batch-submit',
  /** 批量关闭 */
  InboundBatchClose = 'demander:warehouse-inward-order-management:batch-close',
  /** 新建入库单 */
  InboundAdd = 'demander:warehouse-inward-order-management:create-inward-orders',
  /** 批量删除 */
  InboundBatchDelete = 'demander:warehouse-inward-order-management:batch-delete',
  /** 打印 */
  InboundPrint = 'demander:warehouse-inward-order-management:print',
  /** 批量打印 */
  InboundBatchPrint = 'demander:warehouse-inward-order-management:batch-print',
  /** 批量修改业务日期 */
  InboundBatchUpdateBusinessDate = 'purchase:inbound:batchUpdateBusinessDate',
  /** 批量修改业务标签 */
  InboundBatchUpdateLabel = 'purchase:inbound:batchUpdateLabel',
  /**  ================================ '出库单管理 ================================ '*/
  /** 查看出库单 */
  OutboundView = 'demander:warehouse-outward-order-management:view-outward-orders',
  /** 编辑出库单 */
  OutboundEdit = 'demander:warehouse-outward-order-management:edit-outward-orders',
  /** 提交出库单 */
  OutboundSubmit = 'demander:warehouse-outward-order-management:submit-outward-orders',
  /** 关闭出库单 */
  OutboundClose = 'demander:warehouse-outward-order-management:close-outward-orders',
  /** 删除出库单 */
  OutboundDelete = 'demander:warehouse-outward-order-management:delete-outward-orders',
  /** 批量导出 */
  OutboundExport = 'demander:warehouse-outward-order-management:batch-export',
  /** 批量提交 */
  OutboundBatchSubmit = 'demander:warehouse-outward-order-management:batch-submit',
  /** 批量关闭 */
  OutboundBatchClose = 'demander:warehouse-outward-order-management:batch-close',
  /** 新建入库单 */
  OutboundAdd = 'demander:warehouse-outward-order-management:create-outward-orders',
  /** 批量删除 */
  OutboundBatchDelete = 'demander:warehouse-outward-order-management:batch-delete',
  /** 打印 */
  OutboundPrint = 'demander:warehouse-outward-order-management:print',
  /** 批量打印 */
  OutboundBatchPrint = 'demander:warehouse-outward-order-management:batch-print',
  /** 批量修改业务日期 */
  OutboundBatchUpdateBusinessDate = 'purchase:outbound:batchUpdateBusinessDate',
  /** 批量修改业务标签 */
  OutboundBatchUpdateLabel = 'purchase:outbound:batchUpdateLabel',

  /**  ================================ 申领单管理 ================================ */
  /** 查看申领单 */
  RequisitionView = 'demand:reconciliation-management:order-apply-view',
  /** 新建申领单 */
  RequisitionNew = 'demand:reconciliation-management:order-apply-add',
  /** 编辑申领单 */
  RequisitionEdit = 'demand:reconciliation-management:order-apply-edit',
  /** 提交申领单 */
  RequisitionSubmit = 'demand:reconciliation-management:order-apply-submit',
  /** 完成申领单 */
  RequisitionComplete = 'demand:reconciliation-management:order-apply-complete',
  /** 关闭申领单 */
  RequisitionClose = 'demand:reconciliation-management:order-apply-close',
  /** 删除申领单 */
  RequisitionDelete = 'demand:reconciliation-management:order-apply-delete',
  /** 批量导出 */
  RequisitionBatchExport = 'demand:reconciliation-management:order-apply-exportExcel',
  /** 批量提交 */
  RequisitionBatchSubmit = 'demand:reconciliation-management:order-apply-batchSubmit',
  /** 批量关闭 */
  RequisitionBatchClose = 'demand:reconciliation-management:order-apply-batchClose',
  /** 批量删除 */
  RequisitionBatchDelete = 'demand:reconciliation-management:order-apply-batchDelete',
  /** 打印 */
  RequisitionPrint = 'demand:reconciliation-management:order-print',
  /** 批量打印 */
  RequisitionBatchPrint = 'demand:reconciliation-management:order-batch-print',
  /**  ================================ 商品预警 ================================ '*/
  /** 发起盘点 */
  WarnSendStock = 'demand:stock-register:shelfLife-takeStockDetail',
  /** 发起申购 */
  WarnApplyPurchase = 'demand:stock-register:shelfLife-purchaseRequestDetail',
  /** 发起采购 */
  WarnPurchase = 'demand:stock-register:shelfLife-purchaseDetail',
  /** 批量导出 */
  WarnExport = 'demand:stock-register:shelfLife-export',
  /**  ================================ 补货规则 ================================ '*/
  /** 查看列表 */
  ReplenishRulesList = 'demand:stock-register:supplement-list',
  /** 新增补货规则 */
  ReplenishRulesCreate = 'demand:stock-register:supplement-add',
  /** 编辑补货规则 */
  ReplenishRulesEdit = 'demand:stock-register:supplement-edit',
  /** 删除补货规则 */
  ReplenishRulesDelete = 'demand:stock-register:supplement-delete',
  /** 批量导入 */
  ReplenishRulesBatchImport = 'demand:stock-register:supplement-batchImport',
  /** 批量导出 */
  ReplenishRulesExport = 'demand:stock-register:supplement-export',
  /** 批量删除 */
  ReplenishRulesBatchDelete = 'demand:stock-register:supplement-batchDelete',
  /**  ================================ '库存台账 ================================ '*/
  /** 批量导出 */
  InventoryLedgerExport = 'demander:inventory-ledger:batch-export',
  /**  ================================ '实时库存 ================================ '*/
  /** 批量导出 */
  RealInventoryExport = 'demander:real-time-inventory:batch-export',
  /**  ================================ '盘点单 ================================ '*/
  /** 查看盘点单 */
  InvntoryView = 'demander:inventory-counting-order:view-counting-orders',
  /** 新建盘点 */
  InvntoryCreate = 'demander:inventory-counting-order:create-counting-orders',
  /** 编辑盘点 */
  InvntoryEdit = 'demander:inventory-counting-order:edit-counting-orders',
  /** 抄库 */
  InvntoryCopy = 'demander:inventory-counting-order:copy-inventory',
  /** 盘点 */
  Invntory = 'demander:inventory-counting-order:conduct-counting',
  /** 完成盘点 */
  InvntoryFinish = 'demander:inventory-counting-order:complete-counting-orders',
  /** 过账 */
  InvntoryPosted = 'demander:inventory-counting-order:post-counting-orders',
  /** 关闭盘点 */
  InvntoryClose = 'demander:inventory-counting-order:close-counting-orders',
  /** 删除盘点 */
  InvntoryDelete = 'demander:inventory-counting-order:delete-counting-orders',
  /** 盘点导出 */
  InvntoryExport = 'demander:inventory-counting-order:batch-export',
  /** 批量完成盘点 */
  InvntoryBatchFinish = 'demander:inventory-counting-order:batch-complete',
  /** 批量关闭盘点 */
  InvntoryBatchClose = 'demander:inventory-counting-order:batch-close',
  /** 批量删除盘点 */
  InvntoryBatchDelete = 'demander:inventory-counting-order:batch-delete',
  /**  ================================ '物料转换 ================================ '*/
  /** 查看物料转换 */
  MaterialConversionView = 'demander:material-conversion:view-conversion',
  /** 批量转换 */
  MaterialConversionBacthChange = 'demander:material-conversion:batch-conversion',
  /** 新建物料转换 */
  MaterialConversionCreate = 'demander:material-conversion:create-conversion-order',
  /** 编辑物料转换 */
  MaterialConversionEdit = 'demander:material-conversion:edit-conversion-order',
  /** 完成物料转换 */
  MaterialConversionFinish = 'demander:material-conversion:complete-conversion-order',
  /** 关闭物料转换 */
  MaterialConversionClose = 'demander:material-conversion:close-conversion-order',
  /** 删除物料转换 */
  MaterialConversionDelete = 'demander:material-conversion:delete-conversion-order',
  /** 批量导出 */
  MaterialConversionExport = 'demander:material-conversion:batch-export',
  /** 批量完成 */
  MaterialConversionBatchFinish = 'demander:material-conversion:batch-complete',
  /** 批量关闭 */
  MaterialConversionBatchClose = 'demander:material-conversion:batch-close',
  /** 批量删除 */
  MaterialConversionBatchDelete = 'demander:material-conversion:batch-delete',
  /**  ================================ 运营管理-巡检任务 ================================ */
  /** 查看巡检任务 */
  InspectionTaskView = 'demander:patrol-inspection-task:view-tasks',
  /** 新建巡检任务 */
  InspectionTaskCreate = 'demander:patrol-inspection-task:create-tasks',
  /** 编辑巡检任务 */
  InspectionTaskEdit = 'demander:patrol-inspection-task:edit-tasks',
  /** 完成巡检任务 */
  InspectionTaskComplete = 'demander:patrol-inspection-task:complete-tasks',
  /** 关闭巡检任务 */
  InspectionTaskClose = 'demander:patrol-inspection-task:close-tasks',
  /** 删除巡检任务 */
  InspectionTaskDelete = 'demander:patrol-inspection-task:delete-tasks',
  /** 批量关闭 */
  InspectionTaskBatchClose = 'demander:patrol-inspection-task:batch-close',
  /** 批量删除 */
  InspectionTaskBatchDelete = 'demander:patrol-inspection-task:batch-delete',
  /**  ================================ 运营管理-巡检任务模版 ================================ */
  /** 新建巡检任务模版 */
  InspectionTemplateNew = 'demander:patrol-inspection-template:create-template',
  /** 编辑巡检任务模版 */
  InspectionTemplateEdit = 'demander:patrol-inspection-template:edit-template',
  /** 启用巡检任务模版 */
  InspectionTemplateEnable = 'demander:patrol-inspection-template:enable-template',
  /** 禁用巡检任务模版 */
  InspectionTemplateDisable = 'demander:patrol-inspection-template:disable-template',
  /** 删除巡检任务模版 */
  InspectionTemplateDelete = 'demander:patrol-inspection-template:delete-template',
  /** 批量启用 */
  InspectionTemplateBatchEnable = 'demander:patrol-inspection-template:batch-enable',
  /** 批量禁用 */
  InspectionTemplateBatchDisable = 'demander:patrol-inspection-template:batch-disable',
  /** 批量删除 */
  InspectionTemplateBatchDelete = 'demander:patrol-inspection-template:batch-delete',
  /**  ================================ 运营管理-投诉建议 ================================ */
  /** 查看投诉建议 */
  SuggestionView = 'demand:account-records:list',
  /** 删除投诉建议 */
  SuggestionDelete = 'demand:account-records:delete',
  /** 批量删除投诉建议 */
  SuggestionBatchDelete = 'demand:account-records:batch-delete',

  /**  ================================ 留样管理 ================================ '*/
  /** 查看留样 */
  SampleView = 'demand:keep-sample:detail',
  /** 新增留样 */
  SampleCreate = 'demand:keep-sample:add',
  /** 编辑留样 */
  SampleEdit = 'demand:keep-sample:update',
  /** 提交留样 */
  SampleSubmit = 'demand:keep-sample:submit',
  /** 销样 */
  SampleDisposal = 'demand:keep-sample:disposal',
  /** 关闭留样 */
  SampleClose = 'demand:keep-sample:close',
  /** 删除留样 */
  SampleDelete = 'demand:keep-sample:delete',
  /** 批量关闭 */
  SampleBatchClose = 'demand:keep-sample:batchClose',
  /** 批量提交 */
  SampleBatchSunbmit = 'demand:keep-sample:batchSubmit',
  /** 批量删除 */
  SampleBatchDelete = 'demand:keep-sample:batchDelete',
  /**  ================================ 财务汇总表 ================================ */
  /** 批量导出 */
  FinancialSummaryBatchExport = 'demand:revenue:statistics-export',
  /**  ================================ 报餐记录 ================================ */
  /** 报餐记录列表 */
  MealRecordList = 'demand:menu-record:list',
  /** 查看报餐记录 */
  MealRecordView = 'demand:menu-record:view',
  /** 新建报餐记录 */
  MealRecordNew = 'demand:menu-record:add',
  /** 同步缴费人数 */
  MealRecordSyncPay = 'demand:menu-record:slip-count',
  /** 同步请假人数 */
  MealRecordSyncLeave = 'demand:menu-record:leave-count',
  /** 提交报餐记录 */
  MealRecordSubmit = 'demand:menu-record:apply',
  /** 编辑报餐记录 */
  MealRecordEdit = 'demand:menu-record:edit',
  /** 关闭报餐记录 */
  MealRecordClose = 'demand:menu-record:close',
  /** 删除报餐记录 */
  MealRecordDelete = 'demand:menu-record:deleted',
  /** 批量导出报餐记录 */
  MealRecordBatchExport = 'demand:menu-record:export',
  /** 批量提交报餐记录 */
  MealRecordBatchSubmit = 'demand:menu-record:batch-apply',
  /** 批量关闭报餐记录 */
  MealRecordBatchClose = 'demand:menu-record:batch-close',
  /** 批量删除报餐记录 */
  MealRecordBatchDelete = 'demand:menu-record:batch-deleted',
  /**  ================================ 新品提报 ================================ */
  /** 新品提报列表 */
  NewSubmissionList = 'demander:product-report:list',
  /** 新建新品提报 */
  NewSubmissionCreate = 'demander:product-report:add',
  /** 编辑新品提报 */
  NewSubmissionEdit = 'demander:product-report:update',
  /** 删除新品提报 */
  NewSubmissionDelete = 'demander:product-report:delete',
  /**  ================================ 班级管理 ================================ */
  /** 班级管理列表 */
  ClassList = 'demander:class:list',
  /** 新建班级*/
  ClassCreate = 'demander:class:add',
  /** 编辑班级 */
  ClassEdit = 'demander:class:update',
  /** 删除班级 */
  ClassDelete = 'demander:class:delete',
  /** 启用班级 */
  ClassEnable = 'demander:class:enable',
  /** 禁用班级 */
  ClassDisable = 'demander:class:disable',
  /** 导入 */
  ClassImport = 'demander:class:import',
  /** 批量编辑 */
  ClassBatchEdit = 'demander:class:batchUpdate',
  /** 批量启用 */
  ClassBatchEnable = 'demander:class:batchEnable',
  /** 批量禁用 */
  ClassBatchDisable = 'demander:class:batchDisable',
  /** 批量删除 */
  ClassBatchDelete = 'demander:class:batchDelete',
  /**  ================================ 就餐人员 ================================ */
  /** 就餐人员管理列表 */
  DineList = 'demander:diners:list',
  /** 新建就餐人员*/
  DineCreate = 'demander:diners:add',
  /** 编辑就餐人员 */
  DineEdit = 'demander:diners:update',
  /** 删除就餐人员 */
  DineDelete = 'demander:diners:delete',
  /** 启用就餐人员 */
  DineEnable = 'demander:diners:enable',
  /** 禁用就餐人员 */
  DineDisable = 'demander:diners:disable',
  /** 导入 */
  DineImport = 'demander:diners:import',
  /** 导出 */
  DineExport = 'demander:diners:export',
  /** 批量启用 */
  DineBatchEnable = 'demander:diners:batchEnable',
  /** 批量禁用 */
  DineBatchDisable = 'demander:diners:batchDisable',
  /** 批量删除 */
  DineBatchDelete = 'demander:diners:batchDelete',

  /**  ================================ 组合商品 ================================ */
  /** 组合商品查看 */
  CombinationProductView = 'supervisor:combined-commodity-purchaser:view-combined-commodities',
  /** 组合商品新建 */
  CombinationProductCreate = 'supervisor:combined-commodity-purchaser:create-combined-commodities',
  /** 组合商品编辑 */
  CombinationProductEdit = 'supervisor:combined-commodity-purchaser:edit-combined-commodities',
  /** 组合商品启用 */
  CombinationProductEnable = 'supervisor:combined-commodity-purchaser:enable-combined-commodities',
  /** 组合商品禁用 */
  CombinationProductDisEnable = 'supervisor:combined-commodity-purchaser:disable-combined-commodities',
  /** 组合商品删除 */
  CombinationProductDelect = 'supervisor:combined-commodity-purchaser:delete-combined-commodities',
  /** 组合商品批量导入 */
  CombinationProductBatchImport = 'supervisor:combined-commodity-purchaser:batch-import',
  /** 组合商品批量导出 */
  CombinationProductBatchExport = 'supervisor:combined-commodity-purchaser:batch-export',
  /** 组合商品批量启用 */
  CombinationProductBatchEnable = 'supervisor:combined-commodity-purchaser:batch-enable',
  /** 组合商品批量禁用 */
  CombinationProductBatchDisEnable = 'supervisor:combined-commodity-purchaser:batch-disable',
  /** 组合商品批量删除 */
  CombinationProductBatchDelect = 'supervisor:combined-commodity-purchaser:batch-delete',
  /**  ================================ 晨检记录 ================================ */
  /** 晨检记录列表 */
  MorningCheckList = 'demand:morningInspection:queryList',
  /** 查看晨检记录 */
  MorningCheckView = 'demand:morningInspection:getInfo',
  /** 新增晨检记录 */
  MorningCheckAdd = 'demand:morningInspection:add',
  /** 编辑晨检记录 */
  MorningCheckEdit = 'demand:morningInspection:update',
  /** 删除晨检记录 */
  MorningCheckDelete = 'demand:morningInspection:delete',
  /** 批量删除晨检记录 */
  MorningCheckBatchDelete = 'demand:morningInspection:batch-delete',
  /**  ================================ 消杀记录 ================================ */
  /** 消杀记录列表 */
  DisinfectList = 'supervisor:disinfect-purchaser:list',
  /** 查看消杀记录 */
  DisinfectView = 'supervisor:disinfect-purchaser:detail',
  /** 新建消杀记录 */
  DisinfectAdd = 'supervisor:disinfect-purchaser:create',
  /** 编辑消杀记录 */
  DisinfectEdit = 'supervisor:disinfect-purchaser:edit',
  /** 删除消杀记录 */
  DisinfectDelete = 'supervisor:disinfect-purchaser:delete',
  /** 消杀区域/物品管理 */
  DisinfectManageList = 'supervisor:disinfect-purchaser:manage-detail-list',
  /** 批量删除消杀记录 */
  DisinfectBatchDelete = 'supervisor:disinfect-purchaser:batch-delete',
  /**  ================================ 陪餐 ================================ */
  /** 陪餐记录列表 */
  AccompanyList = 'demander:mealAccompanimentRecord:list',
  /** 查看陪餐记录 */
  AccompanyView = 'demander:mealAccompanimentRecord:page',
  /** 新建陪餐记录 */
  AccompanyAdd = 'demander:mealAccompanimentRecord:add',
  /** 编辑陪餐记录 */
  AccompanyEdit = 'demander:mealAccompanimentRecord:update',
  /** 删除陪餐记录 */
  AccompanyDelete = 'demander:mealAccompanimentRecord:delete',
  /** 批量删除陪餐记录 */
  AccompanyBatchDelete = 'demander:mealAccompanimentRecord:batchDelete',
  /**  ================================ 缴费单 ================================ */
  /** 缴费单查看列表 */
  PaymentReceiptList = 'demander:payment-slip:list',
  /** 缴费单查看 */
  PaymentReceiptView = 'demander:payment-slip:page',
  /** 缴费单新建 */
  PaymentReceiptCreate = 'demander:payment-slip:add',
  /** 缴费单编辑 */
  PaymentReceiptEdit = 'demander:payment-slip:update',
  /** 缴费单发布 */
  PaymentReceiptPublish = 'demander:payment-slip:public',
  /** 缴费单关闭 */
  PaymentReceiptClose = 'demander:payment-slip:close',
  /** 缴费单删除 */
  PaymentReceiptDelect = 'demander:payment-slip:delete',
  /** 缴费单批量导出 */
  PaymentReceiptBatchExport = 'demander:payment-slip:export',
  /** 缴费单批量发布 */
  PaymentReceiptBatchPublish = 'demander:payment-slip:batch-public',
  /** 缴费单批量关闭 */
  PaymentReceiptBatchClose = 'demander:payment-slip:batch-close',
  /** 缴费单批量删除 */
  PaymentReceiptBatchDelect = 'demander:payment-slip:batch-delete',
  /**  ================================ 缴费记录 ================================ */
  /** 缴费记录查看列表 */
  PaymentRecordsList = 'demander:payment-slip-record:list',
  /** 缴费记录查看 */
  PaymentRecordsView = 'demander:payment-slip-record:page',
  /** 缴费记录新建 */
  PaymentRecordsCreate = 'demander:payment-slip-record:add',
  /** 缴费记录编辑 */
  PaymentRecordsEdit = 'demander:payment-slip-record:update',
  /** 缴费记录请假 */
  PaymentRecordsAskForLeave = 'demander:payment-slip-record:askForLeave',
  /** 缴费记录删除 */
  PaymentRecordsDelect = 'demander:payment-slip-record:delete',
  /** 缴费记录批量导入 */
  PaymentRecordsBatchImport = 'demander:payment-slip-record:import',
  /** 缴费记录批量导出 */
  PaymentRecordsBatchExport = 'demander:payment-slip-record:export',
  /** 缴费记录批量删除 */
  PaymentRecordsBatchDelect = 'demander:payment-slip-record:batchExport',
  /**  ================================ 餐费汇总 ================================ */
  /** 餐费汇总查看列表 */
  AccompanySummaryList = 'demander:summary-meal:list',
  /** 餐费汇总批量导出 */
  AccompanySummaryBatchExport = 'demander:summary-meal:export',
  /**  ================================ 违规记录 ================================ */
  /** 违规记录列表 */
  ViolationList = 'demander:violation-record:list',
  /** 删除违规记录 */
  ViolationDelete = 'demander:violation-record:delete',
  /** 批量删除 */
  ViolationBatchDelete = 'demander:violation-record:batch-delete',
  /**  ================================ 就餐日历 ================================ */
  /** 就餐日历列表 */
  DiningCalendarList = 'demander:dining-calender:list',
  /** 就餐日历导出 */
  DiningCalendarExport = 'demander:dining-calender:export',
  /**  ================================ 仓库管理 ================================ */
  /** 仓库管理列表 */
  WarehouseList = 'demand:reconciliation-management:stock:list',
  /** 新建仓库 */
  WarehouseCreate = 'demand:reconciliation-management:stock:add',
  /** 编辑仓库 */
  WarehouseEdit = 'demand:reconciliation-management:stock:edit',
  /** 启用仓库 */
  WarehouseEnable = 'demand:reconciliation-management:stock:enable',
  /** 禁用仓库 */
  WarehouseDisable = 'demand:reconciliation-management:stock:disenable',
  /** 删除仓库 */
  WarehouseDelete = 'demand:reconciliation-management:stock:deleted',
  /** 批量启用仓库 */
  WarehouseBatchEnable = 'demand:reconciliation-management:stock:batch-enable',
  /** 批量禁用仓库 */
  WarehouseBatchDisable = 'demand:reconciliation-management:stock:batch-disenable',
  /** 批量删除仓库 */
  WarehouseBatchDelete = 'demand:reconciliation-management:stock:batch-deleted',

  /**  ================================ 售后单 ================================ */
  /** 售后单查看列表 */
  AfterSalesList = 'demander:after-sale:list',
  /** 售后单查看明细 */
  AfterSalesDetail = 'demander:after-sale:page',
  /** 售后单新建 */
  AfterSalesCreate = 'demander:after-sale:add',
  /** 售后单编辑 */
  AfterSalesEdit = 'demander:after-sale:update',
  /** 售后单审核 */
  AfterSalesReview = 'demander:after-sale:check',
  /** 退货 */
  AfterSalesReturn = 'demander:after-sale:return',
  /** 售后单对账 */
  AfterSalesStatement = 'demander:after-sale:add-statement',
  /** 退货记录 */
  AfterSalesReturnRecord = 'demander:after-sale:update-return-record',
  /** 验收记录 */
  AfterSalesCheckRecord = 'demander:after-sale:acceptance-record',
  /** 售后单关闭 */
  AfterSalesClose = 'demander:after-sale:close',
  /** 售后单删除 */
  AfterSalesDelete = 'demander:after-sale:delete',
  /** 售后单导出 */
  AfterSalesExport = 'demander:after-sale:batch-export',
  /** 售后单批量退货 */
  AfterSalesBatchReturn = 'demander:after-sale:batch-return',
  /** 售后单批量对账 */
  AfterSalesBatchStatement = 'demander:after-sale:batch-statement',
  /** 售后单批量关闭 */
  AfterSalesBatchClose = 'demander:after-sale:batch-close',
  /** 售后单批量删除 */
  AfterSalesBatchDelete = 'demander:after-sale:batch-delete',
  /** 售后单打印 */
  AfterSalesPrint = 'demander:after-sale:print',
  /** 售后单批量打印 */
  AfterSalesBatchPrint = 'demander:after-sale:batch-print',
  /**  ================================ 食堂 ================================ */
  /** 食堂列表 */
  DiningList = 'supervisor:canteen:page',
  /** 食堂查看 */
  DiningView = 'supervisor:canteen:list',
  /** 食堂新增 */
  DiningCreate = 'supervisor:canteen:add',
  /** 食堂编辑 */
  DiningEdit = 'supervisor:canteen:update',
  /** 食堂启用 */
  DiningEnable = 'supervisor:canteen:enable',
  /** 食堂禁用 */
  DiningDisable = 'supervisor:canteen:disable',
  /** 食堂删除 */
  DiningDelete = 'supervisor:canteen:delete',
  /** 食堂批量启用 */
  DiningBatchEnable = 'supervisor:canteen:batch-enable',
  /** 食堂批量禁用 */
  DiningBatchDisable = 'supervisor:canteen:batch-disable',
  /** 食堂批量删除 */
  DiningBatchDelete = 'supervisor:canteen:batch-delete',
  /** 食堂出入库规则 */
  DiningInboundOutboundRule = 'demander:canteen:stock-rule',
  /**  ================================ 档口 ================================ */
  /** 档口列表 */
  StallList = 'supervisor:stall:page',
  /** 档口查看 */
  StallView = 'supervisor:stall:list',
  /** 档口新增 */
  StallCreate = 'supervisor:stall:add',
  /** 档口编辑 */
  StallEdit = 'supervisor:stall:edit',
  /** 档口启用 */
  StallEnable = 'supervisor:stall:enable',
  /** 档口禁用 */
  StallDisable = 'supervisor:stall:disable',
  /** 档口删除 */
  StallDelete = 'supervisor:stall:delete',
  /** 档口批量启用 */
  StallBatchEnable = 'supervisor:stall:batch-enable',
  /** 档口批量禁用 */
  StallBatchDisable = 'supervisor:stall:batch-disable',
  /** 档口批量删除 */
  StallBatchDelete = 'supervisor:stall:batch-delete',
  /**  ================================ 商品行情价 ================================ */
  /** 商品行情价查看列表 */
  MarketPriceList = 'demander:market-price:list',
  /** 商品行情价查看明细 */
  MarketPriceDetail = 'demander:market-price:get-info',
  /**  ================================ 采购明细表 ================================ */
  /** 采购明细列表 */
  PurchaseDetailList = 'demand:purchase-summary:list',
  /** 批量导出 */
  PurchaseDetailBatchExport = 'demand:purchase-summary:export',
  /**  ================================ 库存统计表 ================================ */
  /** 库存统计表 */
  StockDetailList = 'demand:purchase-register:list',
  /** 批量导出 */
  StockDetailBatchExport = 'demand:purchase-register:export',
  /**  ================================ '询价管理 ================================ '*/
  /** 查看询价单 */
  InquiryView = 'demand:inquiry-management:view-inquiry-orders',
  /** 编辑询价单 */
  InquiryEdit = 'demand:inquiry-management:edit-inquiry-orders',
  /** 发布询价单 */
  InquiryPublish = 'demand:inquiry-management:publish-inquiry-orders',
  /** 终止发布 */
  InquiryCancelPublish = 'demand:inquiry-management:suspend-inquiry-orders',
  /** 延期询价单 */
  InquiryDelay = 'demand:inquiry-management:extend-inquiry-orders',
  /** 比价定价 */
  InquiryCompare = 'demand:inquiry-management:compare-prices-and-set-prices',
  /** 复制询价单 */
  InquiryCopy = 'demand:inquiry-management:copy-inquiry-orders',
  /** 关闭询价单 */
  InquiryClose = 'demand:inquiry-management:close-inquiry-orders',
  /** 删除询价单 */
  InquiryDelete = 'demand:inquiry-management:delete-inquiry-orders',
  /** 批量发布 */
  InquiryBatchPublish = 'demand:inquiry-management:batch-publish',
  /** 批量终止 */
  InquiryBatchCancelPublish = 'demand:inquiry-management:batch-suspend',
  /** 批量延期 */
  InquiryBatchDelay = 'demand:inquiry-management:batch-extend',
  /** 批量关闭 */
  InquiryBatchClose = 'demand:inquiry-management:batch-close',
  /** 新增询价单 */
  InquiryNew = 'demand:inquiry-management:create-inquiry-orders',
  /** 询价单取消公示 */
  InquiryCancelPublic = 'demand:inquiry-management:update-cancel-public',
  /** 询价单公示 */
  InquiryPublic = 'demand:inquiry-management:update-public',
  /** 批量取消公示 */
  InquiryBatchCancelPublic = 'demand:inquiry-management:batch-update-cancel-public',
  /** 批量公示 */
  InquiryBatchPublic = 'demand:inquiry-management:batch-update-public',
  /** 批量询价 */
  InquiryBatchGenerate = 'demand:inquiry-management:batch-add-inquiry',

  /**  ================================ '询价投票 ================================ '*/
  /** 投票 */
  InquiryVoteSubmit = 'demand:inquiryVoting:vote',
  /** 查看投票结果 */
  InquiryVoteResult = 'demand:inquiryVoting:result',
  /**  ================================ '报价管理 ================================ '*/
  /** 查看报价单 */
  QuoteView = 'demand:quotation-management:view-quotation-orders',
  /** 生产采购合同 */
  QuoteContract = 'demand:quotation-management:generate-purchase-contracts',

  /**  ================================ '采购合同管理 ================================ '*/
  /** 查看采购合同 */
  ContractView = 'demand:purchase-contract-list:view-purchase-contracts',
  /** 编辑采购合同 */
  ContractEdit = 'demand:purchase-contract-list:edit-purchase-contracts',
  /** 发布采购合同 */
  ContractPublish = 'demand:purchase-contract-list:publish-purchase-contracts',
  /** 关闭采购合同 */
  ContractClose = 'demand:purchase-contract-list:close-purchase-contracts',
  /** 删除采购合同 */
  ContractDelete = 'demand:purchase-contract-list:delete-purchase-contracts',
  /** 批量发布 */
  ContractBatchPublish = 'demand:purchase-contract-list:batch-publish',
  /** 批量关闭 */
  ContractBatchClose = 'demand:purchase-contract-list:batch-close',
  /** 批量删除 */
  ContractBatchDelete = 'demand:purchase-contract-list:batch-delete',
  /** 批量改价 */
  ContractBatchModifyPrice = 'demand:purchase-contract-list:batch-change-price',
  /** 批量导出 */
  ContractBatchExport = 'demand:purchase-contract-list:publish-purchase-export',
  /**  ================================ 每日价格 ================================ '*/
  /** 每日价格列表 */
  DailyPriceList = 'demander:daily-price:list',
  /** 每日价格导出 */
  DailyPriceExport = 'demander:daily-price:export',
  /**  ================================ 执行记录台账 ================================ */
  /** 执行记录台账列表  */
  ExecutionRecordLedgerList = 'demand:executionRecordLedger:queryList',
  /** 执行记录台账详情 */
  ExecutionRecordLedgerDetail = 'demand:executionRecordLedger:getInfo',
  /** 执行记录台账创建 */
  ExecutionRecordLedgerCreate = 'demand:executionRecordLedger:add',
  /** 执行记录台账删除 */
  ExecutionRecordLedgerDelete = 'demand:executionRecordLedger:delete',
  /** 执行记录台账重命名 */
  ExecutionRecordLedgerEdit = 'demand:executionRecordLedger:editor',
  /** 执行记录台账批量删除 */
  ExecutionRecordLedgerBatchDelete = 'demand:executionRecordLedger:batchDelete',
  /**  ================================ 整改记录 ================================ */
  /** 整改记录列表 */
  RectificationRecordList = 'demnad:inspection:history:list',
  /** 批量导出 */
  RectificationRecordBatchExport = 'demnad:inspection:history:export',
  /**  ================================ 采购评价表 ================================ */
  /** 采购评价列表 */
  PurchaseEvaluateList = 'demander:purchase-summary-eval:list',
  /** 批量导出 */
  PurchaseEvaluateBatchExport = 'demander:purchase-summary-eval:batch-export',
  /**  ================================ 售后明细表 ================================ */
  /** 明细列表 */
  AfterSaleDetailList = 'demander:after-sale-detail-summary:list',
  /** 批量导出 */
  AfterSaleDetailBatchExport = 'demander:after-sale-detail-summary:batch-export',
  /**  ================================ 对账明细表 ================================ */
  /** 对账明细表列表 */
  StatementDetailList = 'demand:statement-details-statistics:list',
  /** 对账明细表导出 */
  StatementDetailExport = 'demand:statement-details-statistics:expot',
  /**  ================================ 周转筐借还 ================================ */
  /** 周转筐借还列表 */
  TurnoverBasketRecordList = 'demander:basket-record:list',
  /** 周转筐借还详情 */
  TurnoverBasketRecordDetail = 'demander:basket-record:page',
  /**  ================================ 采购进度 ================================ */
  /** 采购进度列表 */
  PurchaseProgressList = 'demander:purchase-process:list',
  /**  ================================ 食安考培 ================================ */
  /** 课程试卷列表 */
  CourseExamPaperList = 'demand:course-examPaper:list',
  /** 课程试卷详情 */
  CourseExamPaperDetail = 'demand:course:info',
  /** 答题 */
  CourseExamPaperAnswer = 'demand:course:answering-questions',
  /** 查看答卷 */
  CourseExamPaperView = 'demand:course:answerInfo',
  /**  ================================ 收据 ================================ */
  /** 收据列表 */
  ReceiptList = 'demand:platformReceipt:list',
  /** 查看收据 */
  ReceiptView = 'demand:platformReceipt:info',
  /** 编辑收据 */
  ReceiptEdit = 'demand:course:answerInfo',
  /** 导出收据 */
  ReceiptExport = 'demand:platformReceipt:export',
  /**  ================================ 工单管理 ================================ */
  /** 查看工单 */
  WorkOrderView = 'purchase:workOrder:page',
  /** 新建工单 */
  WorkOrderAdd = 'purchase:workOrder:add',
  /** 编辑工单 */
  WorkOrderEdit = 'purchase:workOrder:update',
  /** 删除工单 */
  WorkOrderDelete = 'purchase:workOrder:delete',
  /** 批量删除工单 */
  WorkOrderBatchDelete = 'purchase:workOrder:batchDelete',
  /**  ================================ 行车监控 ================================ */
  /** 行车监控列表 */
  VehicleMonitorList = 'demander:delivery-monitoring:list',
  /** 行车监控详情 */
  VehicleMonitorDetail = 'demander:delivery-monitoring:page',
  /**  ================================ 废弃物处理 ================================ */
  /** 废弃物处理列表 */
  WasteDisposalList = 'demander:waste-disposal:queryList',
  /** 废弃物处理详情 */
  WasteDisposalDetail = 'demander:waste-disposal:page',
  /** 废弃物处理新建 */
  WasteDisposalCreate = 'demander:waste-disposal:add',
  /** 废弃物处理编辑 */
  WasteDisposalEdit = 'demander:waste-disposal:update',
  /** 废弃物处理删除 */
  WasteDisposalDelete = 'demander:waste-disposal:delete',
  /** 废弃物处理批量删除 */
  WasteDisposalBatchDelete = 'demander:waste-disposal:batch-delete',
  /**  ================================ 定价审查 ================================ */
  /** 定价审核列表 */
  PriceReviewList = 'demand:pactReview:list',
  /** 导出 */
  PriceReviewExport = 'demand:pactReview:exportDemand',
  /**  ================================ 商品验收审查 ================================ */
  /** 商品验收审查列表 */
  ProductReviewList = 'demand:acceptanceReview:list',
  /** 导出 */
  ProductReviewExport = 'demand:acceptanceReview:export',
}
